import { useState, useEffect } from "react";
import { getAccounts } from "../services/accountService";
import { useSelector } from "react-redux";

type AccountDetailsType = {
  value: string;
  label: string;
  isActive: boolean;
};

export const useAccountDetails = () => {
  const [accountOptions, setAccountOptions] = useState<AccountDetailsType[]>([]);
  const { clientDetails } = useSelector((state: any) => state.clientDetails);

  const getAccountsData = () => {
    getAccounts()
      .then((res) => {
        const accountDetails: AccountDetailsType[] = [];
        res.forEach((account: any) => {
          accountDetails.push({
            value: account.id,
            label: `${account.investorName} - ${account.name} [${account.accountNumber}]`,
            isActive: account.isActive,
          });
        });
        setAccountOptions(accountDetails);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    getAccountsData();
  }, []);

  useEffect(() => {
    getAccountsData();
  }, [clientDetails]);

  return { accountOptions };
};
